<template>
    <fragment>
        <c-header nav-position="right" class="reveal-fade" />
        <main class="site-content">
            <slot />
        </main>
        <c-footer class="reveal-from-bottom" data-reveal-offset="0" />
        <div class="illustration-section-10"></div>
    </fragment>
</template>

<script>
import CHeader from '@/components/layout/Header.vue'
import CFooter from '@/components/layout/Footer.vue'
export default {
  components: {
    CHeader,
    CFooter
  }
}
</script>